import Route from "@ember/routing/route";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class OrganizationsCreateRoute extends Route {
  @service ajax;
  @service store;

  model() {
    return this.ajax.request(`${ENV.apiBaseUri}/country/list`);
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    if (controller.organizationId && !controller.createdOrganization) {
      controller.createdOrganization = this.store.peekRecord("organization", controller.organizationId);
    }
  }

  resetController(controller, ...args) {
    super.resetController(controller, ...args);
    controller.resetController();
  }
}
